import { Box, CircularProgress, Modal } from "@mui/material";
import { useState } from "react";
import Styles from './style.module.css';
// import { setUserData } from "../redux/userSlice";
import { useDispatch } from "react-redux";
import Toastify from "../container/helper/Toastify";
import api from "../container/helper/Api";
import { setLogin } from "../container/redux/userSlice";

const OtpModalAffiliate = ({ closeModal, open, desc, data }) => {
  const [otp, setOtp] = useState("");
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)

  const Data = data
  const styles = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "white",
    border: "none",
    padding: "27px 0px",
    height: "fit-content",
    display: "block",
    width: '600px',
    borderRadius: '7px',
    "&:focus": {
      outline: "none",
    },
  };

  const handleSubmit = async () => {
    // console.log("OTP Submitted:", otp);
    console.log("hlo");

    if (otp.length === 4) {
      console.log("hy");

      try {
        setIsLoading(true)
        const { data, status } = await api.AffiliateconfirmUpdateProfile({ OTP: otp, ...Data })

        if (status === 200) {
          dispatch(setLogin(data?.data?.data))
          Toastify.success("Profile Updated Successfully")
          setOtp("")
          closeModal()
        }
      } catch (error) {
        Toastify.error(error.response.data.message || `something went wrong`);
        setOtp("")
        // closeModal()
      }
      finally {
        setIsLoading(false)
      }
    } else {
      console.log("not clicked");

    }


  };

  // const handleSubmit=async()=>{
  //   console.log("hy");

  // }

  return (
    <Modal
      open={open}
      onClose={closeModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={styles}>
        <div
          className={Styles.entryView}
          style={{
            paddingLeft: 20,
            paddingRight: 20,
            flexDirection: "column",
          }}
        >
          <div className={Styles.headingText} style={{ textAlign: "center" }}>
            Enter Your OTP
          </div>

          <div className={Styles.lineStyle} style={{ width: "100%" }} />
          {desc && (

            <div className={Styles.descStyle}>
              {/* We have sent you an OTP to your vy***@gmail.com, please check and verify. */}
              {desc}

            </div>
          )}

          <input
            type="text"
            placeholder="Enter 4-digit OTP..."
            value={otp}
            onChange={(e) => {
              const input = e.target.value;
              if (/^\d{0,4}$/.test(input)) setOtp(input); // Only allows up to 4 digits
            }}
            className={Styles.otpInput}
          />

          <div className={Styles.buttons}>
            <div onClick={closeModal} className={Styles.cancelStyle}>
              Cancel
            </div>
            <div
              onClick={() => {
                handleSubmit();
              }}
              className={`${Styles.deleteStyle}`}
              style={{
                cursor: otp.length === 4 ? "pointer" : "not-allowed",
                opacity: otp.length === 4 ? 1 : 0.5,
              }}
            >
              {isLoading ? <CircularProgress size="20px" color="inherit" /> : `Submit`}
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default OtpModalAffiliate;
